/* RESPONSIBLE TEAM: team-ai-insights */

import type { CxBenchmarkData } from 'embercom/components/reporting/bespoke/fin-performance/cx-benchmark-panel/types';

// Generated from Snowflake data for 2026-03.
// To regenerate: run extract_benchmarks.sql in Snowsight, download CSV,
// then run: python3 transform_benchmarks.py <csv_file>
export const CX_BENCHMARK_DATA: CxBenchmarkData = {
  benchmarks: {
    'ecommerce:1k_to_15k': {
      percentiles: {
        p5: 0.399,
        p10: 0.4903,
        p15: 0.5302,
        p20: 0.5703,
        p25: 0.5953,
        p30: 0.6107,
        p35: 0.6235,
        p40: 0.6401,
        p45: 0.6544,
        p50: 0.6725,
        p55: 0.6819,
        p60: 0.7073,
        p65: 0.7125,
        p70: 0.7317,
        p75: 0.7524,
        p80: 0.763,
        p85: 0.7951,
        p90: 0.8288,
        p95: 0.8594,
        p100: 1.0,
      },
      reasons: {
        answer_quality_bot_high: 0.7344,
        answer_quality_bot_low: 0.0643,
        product_feedback_positive: 0.0102,
        product_feedback_negative: 0.132,
        policy_feedback_positive: 0.0018,
        policy_feedback_negative: 0.0794,
        user_strong_emotion_positive: 0.0096,
        user_strong_emotion_negative: 0.0727,
        user_effort_low: 0.5365,
        user_effort_high: 0.2195,
      },
      score_distribution: {
        score_1: 0.0077,
        score_2: 0.1381,
        score_3: 0.1823,
        score_4: 0.209,
        score_5: 0.463,
      },
    },

    'ecommerce:overall': {
      percentiles: {
        p5: 0.4096,
        p10: 0.4887,
        p15: 0.5328,
        p20: 0.573,
        p25: 0.5952,
        p30: 0.6137,
        p35: 0.6334,
        p40: 0.6476,
        p45: 0.6592,
        p50: 0.6714,
        p55: 0.6804,
        p60: 0.6943,
        p65: 0.7093,
        p70: 0.7241,
        p75: 0.7487,
        p80: 0.7634,
        p85: 0.7834,
        p90: 0.8108,
        p95: 0.8475,
        p100: 1.0,
      },
      reasons: {
        answer_quality_bot_high: 0.7391,
        answer_quality_bot_low: 0.0663,
        product_feedback_positive: 0.0114,
        product_feedback_negative: 0.1402,
        policy_feedback_positive: 0.0013,
        policy_feedback_negative: 0.0725,
        user_strong_emotion_positive: 0.0091,
        user_strong_emotion_negative: 0.0743,
        user_effort_low: 0.5392,
        user_effort_high: 0.2299,
      },
      score_distribution: {
        score_1: 0.0088,
        score_2: 0.14,
        score_3: 0.177,
        score_4: 0.2142,
        score_5: 0.46,
      },
    },

    'ecommerce:under_1k': {
      percentiles: {
        p5: 0.4113,
        p10: 0.4932,
        p15: 0.5338,
        p20: 0.585,
        p25: 0.617,
        p30: 0.638,
        p35: 0.6461,
        p40: 0.6598,
        p45: 0.6721,
        p50: 0.6804,
        p55: 0.6903,
        p60: 0.702,
        p65: 0.7142,
        p70: 0.7482,
        p75: 0.7589,
        p80: 0.7754,
        p85: 0.7896,
        p90: 0.8062,
        p95: 0.8461,
        p100: 0.9457,
      },
      reasons: {
        answer_quality_bot_high: 0.7422,
        answer_quality_bot_low: 0.0739,
        product_feedback_positive: 0.0144,
        product_feedback_negative: 0.156,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0595,
        user_strong_emotion_positive: 0.0078,
        user_strong_emotion_negative: 0.0699,
        user_effort_low: 0.5358,
        user_effort_high: 0.2596,
      },
      score_distribution: {
        score_1: 0.0081,
        score_2: 0.1432,
        score_3: 0.1601,
        score_4: 0.211,
        score_5: 0.4776,
      },
    },

    'education:1k_to_15k': {
      percentiles: {
        p5: 0.4665,
        p10: 0.5182,
        p15: 0.5703,
        p20: 0.5852,
        p25: 0.6102,
        p30: 0.6379,
        p35: 0.6494,
        p40: 0.6635,
        p45: 0.68,
        p50: 0.7062,
        p55: 0.7326,
        p60: 0.7455,
        p65: 0.7543,
        p70: 0.7691,
        p75: 0.7881,
        p80: 0.8065,
        p85: 0.8164,
        p90: 0.8581,
        p95: 0.8866,
        p100: 1.0,
      },
      reasons: {
        answer_quality_bot_high: 0.7462,
        answer_quality_bot_low: 0.0542,
        product_feedback_positive: 0.0098,
        product_feedback_negative: 0.1191,
        policy_feedback_positive: 0.0013,
        policy_feedback_negative: 0.0532,
        user_strong_emotion_positive: 0.011,
        user_strong_emotion_negative: 0.0581,
        user_effort_low: 0.5195,
        user_effort_high: 0.2522,
      },
      score_distribution: {
        score_1: 0.0055,
        score_2: 0.123,
        score_3: 0.1592,
        score_4: 0.2108,
        score_5: 0.5015,
      },
    },

    'education:overall': {
      percentiles: {
        p5: 0.4818,
        p10: 0.5342,
        p15: 0.5729,
        p20: 0.5961,
        p25: 0.6257,
        p30: 0.6433,
        p35: 0.6574,
        p40: 0.6748,
        p45: 0.6891,
        p50: 0.7064,
        p55: 0.7276,
        p60: 0.745,
        p65: 0.7531,
        p70: 0.7686,
        p75: 0.7846,
        p80: 0.8048,
        p85: 0.8151,
        p90: 0.8422,
        p95: 0.8854,
        p100: 1.0,
      },
      reasons: {
        answer_quality_bot_high: 0.7499,
        answer_quality_bot_low: 0.0553,
        product_feedback_positive: 0.0081,
        product_feedback_negative: 0.1272,
        policy_feedback_positive: 0.0011,
        policy_feedback_negative: 0.0522,
        user_strong_emotion_positive: 0.0102,
        user_strong_emotion_negative: 0.0584,
        user_effort_low: 0.5234,
        user_effort_high: 0.2514,
      },
      score_distribution: {
        score_1: 0.0061,
        score_2: 0.1256,
        score_3: 0.155,
        score_4: 0.2069,
        score_5: 0.5063,
      },
    },

    'education:under_1k': {
      percentiles: {
        p5: 0.5468,
        p10: 0.5781,
        p15: 0.6186,
        p20: 0.6279,
        p25: 0.6481,
        p30: 0.6737,
        p35: 0.6927,
        p40: 0.6995,
        p45: 0.7123,
        p50: 0.7266,
        p55: 0.7414,
        p60: 0.7501,
        p65: 0.7583,
        p70: 0.7782,
        p75: 0.8029,
        p80: 0.8071,
        p85: 0.8341,
        p90: 0.8452,
        p95: 0.8846,
        p100: 0.8983,
      },
      reasons: {
        answer_quality_bot_high: 0.7652,
        answer_quality_bot_low: 0.058,
        product_feedback_positive: 0.0068,
        product_feedback_negative: 0.1339,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0347,
        user_strong_emotion_positive: 0.0068,
        user_strong_emotion_negative: 0.0584,
        user_effort_low: 0.541,
        user_effort_high: 0.2514,
      },
      score_distribution: {
        score_1: 0.0063,
        score_2: 0.1109,
        score_3: 0.147,
        score_4: 0.204,
        score_5: 0.5318,
      },
    },

    'fintech:15k_to_100k': {
      percentiles: {
        p5: 0.4001,
        p10: 0.4726,
        p15: 0.5154,
        p20: 0.5351,
        p25: 0.5434,
        p30: 0.5523,
        p35: 0.5787,
        p40: 0.596,
        p45: 0.615,
        p50: 0.6321,
        p55: 0.6413,
        p60: 0.6589,
        p65: 0.693,
        p70: 0.7075,
        p75: 0.7344,
        p80: 0.7712,
        p85: 0.7785,
        p90: 0.8108,
        p95: 0.8349,
        p100: 0.9399,
      },
      reasons: {
        answer_quality_bot_high: 0.716,
        answer_quality_bot_low: 0.0657,
        product_feedback_positive: 0.0049,
        product_feedback_negative: 0.0839,
        policy_feedback_positive: 0.0012,
        policy_feedback_negative: 0.0976,
        user_strong_emotion_positive: 0.0057,
        user_strong_emotion_negative: 0.0814,
        user_effort_low: 0.5043,
        user_effort_high: 0.2492,
      },
      score_distribution: {
        score_1: 0.0087,
        score_2: 0.1542,
        score_3: 0.199,
        score_4: 0.2033,
        score_5: 0.4348,
      },
    },

    'fintech:1k_to_15k': {
      percentiles: {
        p5: 0.3768,
        p10: 0.4513,
        p15: 0.4998,
        p20: 0.5455,
        p25: 0.5671,
        p30: 0.5878,
        p35: 0.6068,
        p40: 0.6194,
        p45: 0.6407,
        p50: 0.6624,
        p55: 0.6791,
        p60: 0.6941,
        p65: 0.71,
        p70: 0.731,
        p75: 0.7547,
        p80: 0.7723,
        p85: 0.7922,
        p90: 0.8187,
        p95: 0.8635,
        p100: 0.9965,
      },
      reasons: {
        answer_quality_bot_high: 0.7304,
        answer_quality_bot_low: 0.0602,
        product_feedback_positive: 0.0062,
        product_feedback_negative: 0.1104,
        policy_feedback_positive: 0.0007,
        policy_feedback_negative: 0.0731,
        user_strong_emotion_positive: 0.0066,
        user_strong_emotion_negative: 0.0707,
        user_effort_low: 0.4756,
        user_effort_high: 0.2679,
      },
      score_distribution: {
        score_1: 0.0076,
        score_2: 0.1344,
        score_3: 0.1875,
        score_4: 0.2174,
        score_5: 0.4531,
      },
    },

    'fintech:overall': {
      percentiles: {
        p5: 0.3956,
        p10: 0.4651,
        p15: 0.5159,
        p20: 0.5525,
        p25: 0.5767,
        p30: 0.595,
        p35: 0.6097,
        p40: 0.6213,
        p45: 0.6384,
        p50: 0.6588,
        p55: 0.6782,
        p60: 0.6953,
        p65: 0.7127,
        p70: 0.7362,
        p75: 0.7557,
        p80: 0.7776,
        p85: 0.7934,
        p90: 0.8241,
        p95: 0.8601,
        p100: 0.9965,
      },
      reasons: {
        answer_quality_bot_high: 0.7297,
        answer_quality_bot_low: 0.0648,
        product_feedback_positive: 0.0056,
        product_feedback_negative: 0.1048,
        policy_feedback_positive: 0.0006,
        policy_feedback_negative: 0.0733,
        user_strong_emotion_positive: 0.006,
        user_strong_emotion_negative: 0.071,
        user_effort_low: 0.4829,
        user_effort_high: 0.267,
      },
      score_distribution: {
        score_1: 0.0077,
        score_2: 0.1366,
        score_3: 0.1868,
        score_4: 0.2134,
        score_5: 0.4554,
      },
    },

    'fintech:under_1k': {
      percentiles: {
        p5: 0.4707,
        p10: 0.554,
        p15: 0.59,
        p20: 0.602,
        p25: 0.6103,
        p30: 0.6203,
        p35: 0.6281,
        p40: 0.6407,
        p45: 0.6577,
        p50: 0.6795,
        p55: 0.694,
        p60: 0.7143,
        p65: 0.7415,
        p70: 0.7618,
        p75: 0.7781,
        p80: 0.7844,
        p85: 0.8067,
        p90: 0.8324,
        p95: 0.8634,
        p100: 0.9412,
      },
      reasons: {
        answer_quality_bot_high: 0.7411,
        answer_quality_bot_low: 0.0719,
        product_feedback_positive: 0.0054,
        product_feedback_negative: 0.1155,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0571,
        user_strong_emotion_positive: 0.0045,
        user_strong_emotion_negative: 0.0669,
        user_effort_low: 0.4814,
        user_effort_high: 0.2638,
      },
      score_distribution: {
        score_1: 0.007,
        score_2: 0.1235,
        score_3: 0.1705,
        score_4: 0.214,
        score_5: 0.485,
      },
    },

    'gaming_and_gambling:overall': {
      percentiles: {
        p5: 0.3284,
        p10: 0.3543,
        p15: 0.3789,
        p20: 0.4057,
        p25: 0.4363,
        p30: 0.4587,
        p35: 0.4742,
        p40: 0.5002,
        p45: 0.5071,
        p50: 0.5151,
        p55: 0.5432,
        p60: 0.556,
        p65: 0.5723,
        p70: 0.5861,
        p75: 0.6186,
        p80: 0.6445,
        p85: 0.6607,
        p90: 0.711,
        p95: 0.77,
        p100: 0.9127,
      },
      reasons: {
        answer_quality_bot_high: 0.6267,
        answer_quality_bot_low: 0.0867,
        product_feedback_positive: 0.0028,
        product_feedback_negative: 0.1459,
        policy_feedback_positive: 0.0007,
        policy_feedback_negative: 0.1532,
        user_strong_emotion_positive: 0.0067,
        user_strong_emotion_negative: 0.1397,
        user_effort_low: 0.3947,
        user_effort_high: 0.3205,
      },
      score_distribution: {
        score_1: 0.0221,
        score_2: 0.1947,
        score_3: 0.2449,
        score_4: 0.2045,
        score_5: 0.3338,
      },
    },

    'healthcare:1k_to_15k': {
      percentiles: {
        p5: 0.4594,
        p10: 0.5089,
        p15: 0.5503,
        p20: 0.5805,
        p25: 0.61,
        p30: 0.6313,
        p35: 0.6537,
        p40: 0.6612,
        p45: 0.6815,
        p50: 0.6963,
        p55: 0.7063,
        p60: 0.7267,
        p65: 0.7431,
        p70: 0.7515,
        p75: 0.7649,
        p80: 0.7814,
        p85: 0.8057,
        p90: 0.8395,
        p95: 0.8713,
        p100: 0.9603,
      },
      reasons: {
        answer_quality_bot_high: 0.743,
        answer_quality_bot_low: 0.0654,
        product_feedback_positive: 0.0058,
        product_feedback_negative: 0.112,
        policy_feedback_positive: 0.0007,
        policy_feedback_negative: 0.0496,
        user_strong_emotion_positive: 0.0074,
        user_strong_emotion_negative: 0.0613,
        user_effort_low: 0.5445,
        user_effort_high: 0.2401,
      },
      score_distribution: {
        score_1: 0.0063,
        score_2: 0.1272,
        score_3: 0.1724,
        score_4: 0.2114,
        score_5: 0.4827,
      },
    },

    'healthcare:overall': {
      percentiles: {
        p5: 0.4574,
        p10: 0.5,
        p15: 0.5487,
        p20: 0.5802,
        p25: 0.6125,
        p30: 0.6291,
        p35: 0.6538,
        p40: 0.6655,
        p45: 0.6843,
        p50: 0.7009,
        p55: 0.7088,
        p60: 0.7202,
        p65: 0.7356,
        p70: 0.7567,
        p75: 0.7665,
        p80: 0.7844,
        p85: 0.806,
        p90: 0.8333,
        p95: 0.8745,
        p100: 0.9603,
      },
      reasons: {
        answer_quality_bot_high: 0.748,
        answer_quality_bot_low: 0.0628,
        product_feedback_positive: 0.007,
        product_feedback_negative: 0.1114,
        policy_feedback_positive: 0.0006,
        policy_feedback_negative: 0.0551,
        user_strong_emotion_positive: 0.0077,
        user_strong_emotion_negative: 0.0609,
        user_effort_low: 0.5446,
        user_effort_high: 0.2371,
      },
      score_distribution: {
        score_1: 0.0062,
        score_2: 0.1262,
        score_3: 0.1652,
        score_4: 0.2054,
        score_5: 0.497,
      },
    },

    'healthcare:under_1k': {
      percentiles: {
        p5: 0.4878,
        p10: 0.5125,
        p15: 0.5579,
        p20: 0.5894,
        p25: 0.6181,
        p30: 0.6333,
        p35: 0.6684,
        p40: 0.6834,
        p45: 0.6985,
        p50: 0.7116,
        p55: 0.7191,
        p60: 0.7314,
        p65: 0.7592,
        p70: 0.7661,
        p75: 0.7787,
        p80: 0.7926,
        p85: 0.8263,
        p90: 0.8384,
        p95: 0.8901,
        p100: 0.9444,
      },
      reasons: {
        answer_quality_bot_high: 0.7548,
        answer_quality_bot_low: 0.0628,
        product_feedback_positive: 0.0087,
        product_feedback_negative: 0.1186,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0487,
        user_strong_emotion_positive: 0.0082,
        user_strong_emotion_negative: 0.0556,
        user_effort_low: 0.5444,
        user_effort_high: 0.2212,
      },
      score_distribution: {
        score_1: 0.0053,
        score_2: 0.1207,
        score_3: 0.1513,
        score_4: 0.2,
        score_5: 0.5226,
      },
    },

    'hospitality_and_tourism:overall': {
      percentiles: {
        p5: 0.5042,
        p10: 0.55,
        p15: 0.5669,
        p20: 0.6058,
        p25: 0.6345,
        p30: 0.6433,
        p35: 0.6691,
        p40: 0.6824,
        p45: 0.6967,
        p50: 0.7047,
        p55: 0.7101,
        p60: 0.7222,
        p65: 0.7473,
        p70: 0.7743,
        p75: 0.7847,
        p80: 0.7952,
        p85: 0.8191,
        p90: 0.8905,
        p95: 0.8993,
        p100: 0.9308,
      },
      reasons: {
        answer_quality_bot_high: 0.7592,
        answer_quality_bot_low: 0.0596,
        product_feedback_positive: 0.0058,
        product_feedback_negative: 0.0939,
        policy_feedback_positive: 0.0013,
        policy_feedback_negative: 0.0606,
        user_strong_emotion_positive: 0.0085,
        user_strong_emotion_negative: 0.0508,
        user_effort_low: 0.5467,
        user_effort_high: 0.2182,
      },
      score_distribution: {
        score_1: 0.0052,
        score_2: 0.1102,
        score_3: 0.1715,
        score_4: 0.218,
        score_5: 0.4951,
      },
    },

    'manufacturing:overall': {
      percentiles: {
        p5: 0.3922,
        p10: 0.5369,
        p15: 0.5991,
        p20: 0.6021,
        p25: 0.6203,
        p30: 0.6401,
        p35: 0.6564,
        p40: 0.674,
        p45: 0.7166,
        p50: 0.732,
        p55: 0.7389,
        p60: 0.7498,
        p65: 0.7638,
        p70: 0.7765,
        p75: 0.7843,
        p80: 0.8001,
        p85: 0.8176,
        p90: 0.8363,
        p95: 0.849,
        p100: 0.8968,
      },
      reasons: {
        answer_quality_bot_high: 0.7996,
        answer_quality_bot_low: 0.0638,
        product_feedback_positive: 0.013,
        product_feedback_negative: 0.0987,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0382,
        user_strong_emotion_positive: 0.0084,
        user_strong_emotion_negative: 0.05,
        user_effort_low: 0.5724,
        user_effort_high: 0.199,
      },
      score_distribution: {
        score_1: 0.0056,
        score_2: 0.0964,
        score_3: 0.1766,
        score_4: 0.1954,
        score_5: 0.526,
      },
    },

    'media_and_entertainment:overall': {
      percentiles: {
        p5: 0.4258,
        p10: 0.4698,
        p15: 0.4885,
        p20: 0.5182,
        p25: 0.5517,
        p30: 0.5608,
        p35: 0.5669,
        p40: 0.6002,
        p45: 0.6277,
        p50: 0.6393,
        p55: 0.6482,
        p60: 0.6712,
        p65: 0.6777,
        p70: 0.7045,
        p75: 0.7418,
        p80: 0.7605,
        p85: 0.7805,
        p90: 0.7923,
        p95: 0.8221,
        p100: 0.8426,
      },
      reasons: {
        answer_quality_bot_high: 0.6898,
        answer_quality_bot_low: 0.0694,
        product_feedback_positive: 0.008,
        product_feedback_negative: 0.1607,
        policy_feedback_positive: 0.0002,
        policy_feedback_negative: 0.0881,
        user_strong_emotion_positive: 0.0111,
        user_strong_emotion_negative: 0.1091,
        user_effort_low: 0.4261,
        user_effort_high: 0.2946,
      },
      score_distribution: {
        score_1: 0.0122,
        score_2: 0.1763,
        score_3: 0.1741,
        score_4: 0.2133,
        score_5: 0.424,
      },
    },

    'other:1k_to_15k': {
      percentiles: {
        p5: 0.412,
        p10: 0.484,
        p15: 0.507,
        p20: 0.5435,
        p25: 0.5612,
        p30: 0.5855,
        p35: 0.6078,
        p40: 0.6212,
        p45: 0.6411,
        p50: 0.66,
        p55: 0.6845,
        p60: 0.695,
        p65: 0.7146,
        p70: 0.7415,
        p75: 0.7552,
        p80: 0.7684,
        p85: 0.7942,
        p90: 0.8301,
        p95: 0.8736,
        p100: 0.943,
      },
      reasons: {
        answer_quality_bot_high: 0.7432,
        answer_quality_bot_low: 0.0673,
        product_feedback_positive: 0.0074,
        product_feedback_negative: 0.1241,
        policy_feedback_positive: 0.0004,
        policy_feedback_negative: 0.0647,
        user_strong_emotion_positive: 0.0067,
        user_strong_emotion_negative: 0.0714,
        user_effort_low: 0.479,
        user_effort_high: 0.2636,
      },
      score_distribution: {
        score_1: 0.0095,
        score_2: 0.1364,
        score_3: 0.1861,
        score_4: 0.2067,
        score_5: 0.4613,
      },
    },

    'other:overall': {
      percentiles: {
        p5: 0.4374,
        p10: 0.4864,
        p15: 0.5289,
        p20: 0.558,
        p25: 0.5765,
        p30: 0.6025,
        p35: 0.6195,
        p40: 0.6419,
        p45: 0.6597,
        p50: 0.6794,
        p55: 0.6924,
        p60: 0.7096,
        p65: 0.7306,
        p70: 0.7482,
        p75: 0.7674,
        p80: 0.7776,
        p85: 0.803,
        p90: 0.825,
        p95: 0.8684,
        p100: 0.943,
      },
      reasons: {
        answer_quality_bot_high: 0.7364,
        answer_quality_bot_low: 0.0679,
        product_feedback_positive: 0.0087,
        product_feedback_negative: 0.1325,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0563,
        user_strong_emotion_positive: 0.0074,
        user_strong_emotion_negative: 0.0736,
        user_effort_low: 0.4902,
        user_effort_high: 0.2591,
      },
      score_distribution: {
        score_1: 0.0087,
        score_2: 0.1374,
        score_3: 0.1725,
        score_4: 0.2071,
        score_5: 0.4743,
      },
    },

    'other:under_1k': {
      percentiles: {
        p5: 0.4753,
        p10: 0.5113,
        p15: 0.5581,
        p20: 0.5861,
        p25: 0.6052,
        p30: 0.634,
        p35: 0.6551,
        p40: 0.6648,
        p45: 0.681,
        p50: 0.6949,
        p55: 0.7144,
        p60: 0.7275,
        p65: 0.7416,
        p70: 0.7665,
        p75: 0.7739,
        p80: 0.7856,
        p85: 0.8141,
        p90: 0.8216,
        p95: 0.8588,
        p100: 0.9203,
      },
      reasons: {
        answer_quality_bot_high: 0.7369,
        answer_quality_bot_low: 0.0675,
        product_feedback_positive: 0.014,
        product_feedback_negative: 0.1511,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0488,
        user_strong_emotion_positive: 0.0082,
        user_strong_emotion_negative: 0.0728,
        user_effort_low: 0.4965,
        user_effort_high: 0.2569,
      },
      score_distribution: {
        score_1: 0.007,
        score_2: 0.13,
        score_3: 0.1581,
        score_4: 0.2083,
        score_5: 0.4967,
      },
    },

    'overall:100k_to_1m': {
      percentiles: {
        p5: 0.332,
        p10: 0.3589,
        p15: 0.4262,
        p20: 0.4606,
        p25: 0.4762,
        p30: 0.5247,
        p35: 0.5533,
        p40: 0.5765,
        p45: 0.6053,
        p50: 0.6287,
        p55: 0.6639,
        p60: 0.6866,
        p65: 0.6979,
        p70: 0.7083,
        p75: 0.7181,
        p80: 0.7276,
        p85: 0.7459,
        p90: 0.7845,
        p95: 0.8068,
        p100: 0.9262,
      },
      reasons: {
        answer_quality_bot_high: 0.6755,
        answer_quality_bot_low: 0.0778,
        product_feedback_positive: 0.0027,
        product_feedback_negative: 0.1044,
        policy_feedback_positive: 0.0004,
        policy_feedback_negative: 0.0571,
        user_strong_emotion_positive: 0.0043,
        user_strong_emotion_negative: 0.061,
        user_effort_low: 0.3937,
        user_effort_high: 0.3364,
      },
      score_distribution: {
        score_1: 0.0069,
        score_2: 0.1571,
        score_3: 0.2086,
        score_4: 0.2258,
        score_5: 0.4015,
      },
    },

    'overall:15k_to_100k': {
      percentiles: {
        p5: 0.3923,
        p10: 0.4647,
        p15: 0.5042,
        p20: 0.5309,
        p25: 0.5504,
        p30: 0.5681,
        p35: 0.5826,
        p40: 0.5999,
        p45: 0.6171,
        p50: 0.6385,
        p55: 0.6528,
        p60: 0.6696,
        p65: 0.6913,
        p70: 0.7045,
        p75: 0.7199,
        p80: 0.7396,
        p85: 0.7712,
        p90: 0.7864,
        p95: 0.8257,
        p100: 0.9399,
      },
      reasons: {
        answer_quality_bot_high: 0.7063,
        answer_quality_bot_low: 0.0661,
        product_feedback_positive: 0.0049,
        product_feedback_negative: 0.1223,
        policy_feedback_positive: 0.001,
        policy_feedback_negative: 0.0787,
        user_strong_emotion_positive: 0.0064,
        user_strong_emotion_negative: 0.0842,
        user_effort_low: 0.4733,
        user_effort_high: 0.28,
      },
      score_distribution: {
        score_1: 0.0093,
        score_2: 0.1513,
        score_3: 0.1932,
        score_4: 0.2128,
        score_5: 0.4334,
      },
    },

    'overall:1k_to_15k': {
      percentiles: {
        p5: 0.4193,
        p10: 0.4835,
        p15: 0.5261,
        p20: 0.5594,
        p25: 0.5833,
        p30: 0.6048,
        p35: 0.6226,
        p40: 0.643,
        p45: 0.6601,
        p50: 0.6762,
        p55: 0.6946,
        p60: 0.7091,
        p65: 0.7246,
        p70: 0.7431,
        p75: 0.7576,
        p80: 0.7736,
        p85: 0.7928,
        p90: 0.8185,
        p95: 0.8626,
        p100: 1.0,
      },
      reasons: {
        answer_quality_bot_high: 0.7318,
        answer_quality_bot_low: 0.0632,
        product_feedback_positive: 0.0071,
        product_feedback_negative: 0.1338,
        policy_feedback_positive: 0.0006,
        policy_feedback_negative: 0.0491,
        user_strong_emotion_positive: 0.0068,
        user_strong_emotion_negative: 0.0633,
        user_effort_low: 0.4738,
        user_effort_high: 0.2778,
      },
      score_distribution: {
        score_1: 0.0069,
        score_2: 0.1319,
        score_3: 0.1784,
        score_4: 0.2183,
        score_5: 0.4645,
      },
    },

    'overall:overall': {
      percentiles: {
        p5: 0.4314,
        p10: 0.4932,
        p15: 0.5346,
        p20: 0.5642,
        p25: 0.5877,
        p30: 0.6085,
        p35: 0.6277,
        p40: 0.6467,
        p45: 0.6636,
        p50: 0.6805,
        p55: 0.697,
        p60: 0.7104,
        p65: 0.7271,
        p70: 0.7456,
        p75: 0.7605,
        p80: 0.7785,
        p85: 0.7977,
        p90: 0.8228,
        p95: 0.862,
        p100: 1.0,
      },
      reasons: {
        answer_quality_bot_high: 0.7323,
        answer_quality_bot_low: 0.0662,
        product_feedback_positive: 0.007,
        product_feedback_negative: 0.1364,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0457,
        user_strong_emotion_positive: 0.0066,
        user_strong_emotion_negative: 0.0628,
        user_effort_low: 0.4688,
        user_effort_high: 0.2792,
      },
      score_distribution: {
        score_1: 0.0069,
        score_2: 0.1321,
        score_3: 0.1747,
        score_4: 0.2179,
        score_5: 0.4684,
      },
    },

    'overall:under_1k': {
      percentiles: {
        p5: 0.4791,
        p10: 0.5254,
        p15: 0.5661,
        p20: 0.5898,
        p25: 0.6103,
        p30: 0.6288,
        p35: 0.6497,
        p40: 0.6647,
        p45: 0.6803,
        p50: 0.6946,
        p55: 0.7105,
        p60: 0.7268,
        p65: 0.7449,
        p70: 0.7587,
        p75: 0.7731,
        p80: 0.7917,
        p85: 0.8103,
        p90: 0.834,
        p95: 0.8722,
        p100: 0.9653,
      },
      reasons: {
        answer_quality_bot_high: 0.7435,
        answer_quality_bot_low: 0.0704,
        product_feedback_positive: 0.0081,
        product_feedback_negative: 0.1461,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0342,
        user_strong_emotion_positive: 0.0065,
        user_strong_emotion_negative: 0.0571,
        user_effort_low: 0.469,
        user_effort_high: 0.2773,
      },
      score_distribution: {
        score_1: 0.0064,
        score_2: 0.1264,
        score_3: 0.1613,
        score_4: 0.2172,
        score_5: 0.4887,
      },
    },

    'professional_services:1k_to_15k': {
      percentiles: {
        p5: 0.4412,
        p10: 0.5173,
        p15: 0.5366,
        p20: 0.5437,
        p25: 0.5633,
        p30: 0.5938,
        p35: 0.637,
        p40: 0.6488,
        p45: 0.669,
        p50: 0.7024,
        p55: 0.726,
        p60: 0.7274,
        p65: 0.7379,
        p70: 0.7579,
        p75: 0.7798,
        p80: 0.7886,
        p85: 0.8026,
        p90: 0.8363,
        p95: 0.8982,
        p100: 1.0,
      },
      reasons: {
        answer_quality_bot_high: 0.7491,
        answer_quality_bot_low: 0.0592,
        product_feedback_positive: 0.0066,
        product_feedback_negative: 0.1048,
        policy_feedback_positive: 0.0019,
        policy_feedback_negative: 0.0522,
        user_strong_emotion_positive: 0.0084,
        user_strong_emotion_negative: 0.0592,
        user_effort_low: 0.5033,
        user_effort_high: 0.2454,
      },
      score_distribution: {
        score_1: 0.0051,
        score_2: 0.1145,
        score_3: 0.1742,
        score_4: 0.2168,
        score_5: 0.4894,
      },
    },

    'professional_services:overall': {
      percentiles: {
        p5: 0.4183,
        p10: 0.4641,
        p15: 0.5062,
        p20: 0.5373,
        p25: 0.5546,
        p30: 0.5803,
        p35: 0.6151,
        p40: 0.6415,
        p45: 0.6644,
        p50: 0.7022,
        p55: 0.7153,
        p60: 0.7269,
        p65: 0.7501,
        p70: 0.7609,
        p75: 0.7791,
        p80: 0.796,
        p85: 0.8292,
        p90: 0.8627,
        p95: 0.8876,
        p100: 1.0,
      },
      reasons: {
        answer_quality_bot_high: 0.7409,
        answer_quality_bot_low: 0.0683,
        product_feedback_positive: 0.0053,
        product_feedback_negative: 0.1053,
        policy_feedback_positive: 0.0005,
        policy_feedback_negative: 0.0513,
        user_strong_emotion_positive: 0.0078,
        user_strong_emotion_negative: 0.0565,
        user_effort_low: 0.5033,
        user_effort_high: 0.246,
      },
      score_distribution: {
        score_1: 0.0064,
        score_2: 0.1221,
        score_3: 0.1716,
        score_4: 0.2139,
        score_5: 0.486,
      },
    },

    'professional_services:under_1k': {
      percentiles: {
        p5: 0.4137,
        p10: 0.463,
        p15: 0.4979,
        p20: 0.5171,
        p25: 0.5486,
        p30: 0.5748,
        p35: 0.6014,
        p40: 0.6421,
        p45: 0.6651,
        p50: 0.7063,
        p55: 0.714,
        p60: 0.7258,
        p65: 0.7556,
        p70: 0.7634,
        p75: 0.7789,
        p80: 0.8237,
        p85: 0.8384,
        p90: 0.866,
        p95: 0.8773,
        p100: 0.915,
      },
      reasons: {
        answer_quality_bot_high: 0.7345,
        answer_quality_bot_low: 0.0799,
        product_feedback_positive: 0.0047,
        product_feedback_negative: 0.1205,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0463,
        user_strong_emotion_positive: 0.0078,
        user_strong_emotion_negative: 0.0506,
        user_effort_low: 0.5046,
        user_effort_high: 0.246,
      },
      score_distribution: {
        score_1: 0.0071,
        score_2: 0.1228,
        score_3: 0.1662,
        score_4: 0.2138,
        score_5: 0.4901,
      },
    },

    'real_estate:1k_to_15k': {
      percentiles: {
        p5: 0.4519,
        p10: 0.4922,
        p15: 0.5132,
        p20: 0.5382,
        p25: 0.5551,
        p30: 0.6114,
        p35: 0.62,
        p40: 0.6343,
        p45: 0.6481,
        p50: 0.6645,
        p55: 0.6814,
        p60: 0.6971,
        p65: 0.7048,
        p70: 0.7138,
        p75: 0.7345,
        p80: 0.7587,
        p85: 0.78,
        p90: 0.7931,
        p95: 0.8397,
        p100: 0.9182,
      },
      reasons: {
        answer_quality_bot_high: 0.7241,
        answer_quality_bot_low: 0.0752,
        product_feedback_positive: 0.005,
        product_feedback_negative: 0.1373,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0497,
        user_strong_emotion_positive: 0.0057,
        user_strong_emotion_negative: 0.0572,
        user_effort_low: 0.5097,
        user_effort_high: 0.2816,
      },
      score_distribution: {
        score_1: 0.0074,
        score_2: 0.1463,
        score_3: 0.1746,
        score_4: 0.2078,
        score_5: 0.4639,
      },
    },

    'real_estate:overall': {
      percentiles: {
        p5: 0.4753,
        p10: 0.4929,
        p15: 0.5138,
        p20: 0.5368,
        p25: 0.5589,
        p30: 0.6083,
        p35: 0.6203,
        p40: 0.6369,
        p45: 0.6575,
        p50: 0.6696,
        p55: 0.6821,
        p60: 0.7037,
        p65: 0.7114,
        p70: 0.7253,
        p75: 0.7354,
        p80: 0.7471,
        p85: 0.7731,
        p90: 0.7923,
        p95: 0.8219,
        p100: 0.9182,
      },
      reasons: {
        answer_quality_bot_high: 0.7233,
        answer_quality_bot_low: 0.0779,
        product_feedback_positive: 0.0058,
        product_feedback_negative: 0.1395,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0486,
        user_strong_emotion_positive: 0.0054,
        user_strong_emotion_negative: 0.0639,
        user_effort_low: 0.4875,
        user_effort_high: 0.2819,
      },
      score_distribution: {
        score_1: 0.0075,
        score_2: 0.1458,
        score_3: 0.1749,
        score_4: 0.2096,
        score_5: 0.4621,
      },
    },

    'software_and_technology:100k_to_1m': {
      percentiles: {
        p5: 0.3357,
        p10: 0.4606,
        p15: 0.5087,
        p20: 0.5557,
        p25: 0.5734,
        p30: 0.5854,
        p35: 0.6163,
        p40: 0.6289,
        p45: 0.6689,
        p50: 0.6886,
        p55: 0.6932,
        p60: 0.7002,
        p65: 0.7094,
        p70: 0.7181,
        p75: 0.7244,
        p80: 0.7365,
        p85: 0.7562,
        p90: 0.7865,
        p95: 0.806,
        p100: 0.819,
      },
      reasons: {
        answer_quality_bot_high: 0.6944,
        answer_quality_bot_low: 0.0877,
        product_feedback_positive: 0.0027,
        product_feedback_negative: 0.1096,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0142,
        user_strong_emotion_positive: 0.0029,
        user_strong_emotion_negative: 0.0479,
        user_effort_low: 0.3776,
        user_effort_high: 0.3551,
      },
      score_distribution: {
        score_1: 0.0056,
        score_2: 0.1328,
        score_3: 0.1876,
        score_4: 0.2406,
        score_5: 0.4333,
      },
    },

    'software_and_technology:15k_to_100k': {
      percentiles: {
        p5: 0.3698,
        p10: 0.4692,
        p15: 0.5213,
        p20: 0.5489,
        p25: 0.5619,
        p30: 0.5755,
        p35: 0.5872,
        p40: 0.6135,
        p45: 0.6385,
        p50: 0.6514,
        p55: 0.685,
        p60: 0.7006,
        p65: 0.7108,
        p70: 0.7268,
        p75: 0.7372,
        p80: 0.7502,
        p85: 0.773,
        p90: 0.7956,
        p95: 0.827,
        p100: 0.8843,
      },
      reasons: {
        answer_quality_bot_high: 0.7045,
        answer_quality_bot_low: 0.0661,
        product_feedback_positive: 0.0049,
        product_feedback_negative: 0.1424,
        policy_feedback_positive: 0.0004,
        policy_feedback_negative: 0.0326,
        user_strong_emotion_positive: 0.0057,
        user_strong_emotion_negative: 0.0703,
        user_effort_low: 0.4043,
        user_effort_high: 0.3227,
      },
      score_distribution: {
        score_1: 0.0066,
        score_2: 0.1373,
        score_3: 0.186,
        score_4: 0.2284,
        score_5: 0.4418,
      },
    },

    'software_and_technology:1k_to_15k': {
      percentiles: {
        p5: 0.4402,
        p10: 0.4959,
        p15: 0.5381,
        p20: 0.5694,
        p25: 0.5927,
        p30: 0.6116,
        p35: 0.6337,
        p40: 0.6542,
        p45: 0.6724,
        p50: 0.6871,
        p55: 0.6997,
        p60: 0.7133,
        p65: 0.7278,
        p70: 0.7444,
        p75: 0.7582,
        p80: 0.7737,
        p85: 0.7913,
        p90: 0.8132,
        p95: 0.8528,
        p100: 1.0,
      },
      reasons: {
        answer_quality_bot_high: 0.7308,
        answer_quality_bot_low: 0.0627,
        product_feedback_positive: 0.0071,
        product_feedback_negative: 0.1538,
        policy_feedback_positive: 0.0002,
        policy_feedback_negative: 0.0335,
        user_strong_emotion_positive: 0.0059,
        user_strong_emotion_negative: 0.0582,
        user_effort_low: 0.4396,
        user_effort_high: 0.3019,
      },
      score_distribution: {
        score_1: 0.0065,
        score_2: 0.1288,
        score_3: 0.1738,
        score_4: 0.2267,
        score_5: 0.4643,
      },
    },

    'software_and_technology:overall': {
      percentiles: {
        p5: 0.451,
        p10: 0.5131,
        p15: 0.5528,
        p20: 0.5793,
        p25: 0.5966,
        p30: 0.6176,
        p35: 0.6414,
        p40: 0.6587,
        p45: 0.6744,
        p50: 0.6893,
        p55: 0.7035,
        p60: 0.7174,
        p65: 0.733,
        p70: 0.7496,
        p75: 0.7608,
        p80: 0.7801,
        p85: 0.7976,
        p90: 0.8214,
        p95: 0.8568,
        p100: 1.0,
      },
      reasons: {
        answer_quality_bot_high: 0.7319,
        answer_quality_bot_low: 0.066,
        product_feedback_positive: 0.0073,
        product_feedback_negative: 0.1542,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.029,
        user_strong_emotion_positive: 0.0058,
        user_strong_emotion_negative: 0.0565,
        user_effort_low: 0.431,
        user_effort_high: 0.302,
      },
      score_distribution: {
        score_1: 0.0062,
        score_2: 0.1279,
        score_3: 0.17,
        score_4: 0.2266,
        score_5: 0.4694,
      },
    },

    'software_and_technology:under_1k': {
      percentiles: {
        p5: 0.4861,
        p10: 0.5404,
        p15: 0.5758,
        p20: 0.5931,
        p25: 0.6144,
        p30: 0.6357,
        p35: 0.6535,
        p40: 0.6679,
        p45: 0.681,
        p50: 0.6979,
        p55: 0.7114,
        p60: 0.7282,
        p65: 0.746,
        p70: 0.7575,
        p75: 0.7705,
        p80: 0.7906,
        p85: 0.8064,
        p90: 0.8342,
        p95: 0.8711,
        p100: 0.9653,
      },
      reasons: {
        answer_quality_bot_high: 0.7418,
        answer_quality_bot_low: 0.0696,
        product_feedback_positive: 0.0085,
        product_feedback_negative: 0.1604,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0248,
        user_strong_emotion_positive: 0.006,
        user_strong_emotion_negative: 0.0533,
        user_effort_low: 0.4328,
        user_effort_high: 0.2955,
      },
      score_distribution: {
        score_1: 0.0058,
        score_2: 0.1254,
        score_3: 0.1603,
        score_4: 0.2257,
        score_5: 0.4828,
      },
    },

    'transportation:1k_to_15k': {
      percentiles: {
        p5: 0.3787,
        p10: 0.4414,
        p15: 0.4696,
        p20: 0.5088,
        p25: 0.5386,
        p30: 0.5715,
        p35: 0.5785,
        p40: 0.5959,
        p45: 0.6021,
        p50: 0.6154,
        p55: 0.6221,
        p60: 0.6317,
        p65: 0.642,
        p70: 0.6549,
        p75: 0.6612,
        p80: 0.7003,
        p85: 0.7258,
        p90: 0.7542,
        p95: 0.7818,
        p100: 0.862,
      },
      reasons: {
        answer_quality_bot_high: 0.6578,
        answer_quality_bot_low: 0.0876,
        product_feedback_positive: 0.0042,
        product_feedback_negative: 0.1321,
        policy_feedback_positive: 0.0012,
        policy_feedback_negative: 0.083,
        user_strong_emotion_positive: 0.004,
        user_strong_emotion_negative: 0.0829,
        user_effort_low: 0.4692,
        user_effort_high: 0.2986,
      },
      score_distribution: {
        score_1: 0.0077,
        score_2: 0.1768,
        score_3: 0.2157,
        score_4: 0.2173,
        score_5: 0.3824,
      },
    },

    'transportation:overall': {
      percentiles: {
        p5: 0.3605,
        p10: 0.4524,
        p15: 0.4941,
        p20: 0.5132,
        p25: 0.5406,
        p30: 0.5721,
        p35: 0.5812,
        p40: 0.5998,
        p45: 0.6123,
        p50: 0.6278,
        p55: 0.6497,
        p60: 0.6572,
        p65: 0.6769,
        p70: 0.693,
        p75: 0.7079,
        p80: 0.725,
        p85: 0.7545,
        p90: 0.7725,
        p95: 0.8077,
        p100: 0.8761,
      },
      reasons: {
        answer_quality_bot_high: 0.6801,
        answer_quality_bot_low: 0.0897,
        product_feedback_positive: 0.0042,
        product_feedback_negative: 0.115,
        policy_feedback_positive: 0.0006,
        policy_feedback_negative: 0.0849,
        user_strong_emotion_positive: 0.0047,
        user_strong_emotion_negative: 0.0762,
        user_effort_low: 0.4791,
        user_effort_high: 0.2653,
      },
      score_distribution: {
        score_1: 0.0081,
        score_2: 0.1622,
        score_3: 0.1995,
        score_4: 0.2194,
        score_5: 0.4109,
      },
    },
  },
};
